"use strict";
/*
 * Created on 09 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>Structure used during processing of uploaded file related to {@link PriceTermination process}. Contains the core (relevant) data
 * from uploaded file by user and some derived data to ease feedback processing towards user.</p>
 *
 * @see {@link PriceTerminationUpload} for additional info.
 * @author JMe
 * @author Jaroslav Sevcik
 */


var PriceTerminationUploadedItem =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceTerminationUploadedItem, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param id
   * @param uploadId Corresponds to {@link PriceTerminationUpload.id}.
   * @param pExtId Corresponds to {@link Product.externalId}. The value is required part of uploaded file. It is nullable because we want
   *        to process whole CSV file and then show missing required attributes at once.
   * @param gosExtId Corresponds to {@link GroupOfSites.externalId}. The value is required part of uploaded file. It is nullable because
   *        we want to process whole CSV file and then show missing required attributes at once.
   * @param endDate The new end date, at which prices for given combination of product and site should be terminated. The value is
   *        required part of uploaded file. It is nullable because we want to process whole CSV file and then show missing required
   *        attributes at once.
   * @param rowNumber The number of row within source file. The value is derived from uploaded file.
   * @param uploaded The moment the row was uploaded.
   * @param validation Validation result related to the row. The value is result of validation.
   */
  function PriceTerminationUploadedItem(id, uploadId, pExtId, gosExtId, endDate, rowNumber, uploaded, validation) {
    var _this;

    _classCallCheck(this, PriceTerminationUploadedItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceTerminationUploadedItem).call(this));
    _this.id = id;
    _this.uploadId = uploadId;
    _this.pExtId = pExtId;
    _this.gosExtId = gosExtId;
    _this.endDate = endDate;
    _this.rowNumber = rowNumber;
    _this.uploaded = uploaded;
    _this.validation = validation;
    return _this;
  }

  return PriceTerminationUploadedItem;
}(DomainObject_1.DomainObject);

exports.PriceTerminationUploadedItem = PriceTerminationUploadedItem;